var map = {
	"./da-DK.json": 65639,
	"./de-DE.json": 10159,
	"./en-GB.json": 67344,
	"./en-US.json": 53746,
	"./es-ES.json": 96485,
	"./es-MX.json": 18330,
	"./fr-FR.json": 76737,
	"./it-IT.json": 19869,
	"./nb-NO.json": 24861,
	"./nl-NL.json": 72418,
	"./pl-PL.json": 63075,
	"./pt-BR.json": 4845,
	"./pt-PT.json": 49581,
	"./sv-SE.json": 21043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97531;